import { Item } from '@factorialco/deprecated-design-system'

import { getWorkplaceCode } from 'modules/payroll_integrations_a3innuva/lib/a3innuvaHelpers'
import { A3InnuvaMapping } from 'modules/payroll_integrations_a3innuva/lib/types'

const createWorkplaceMapping = (
  workplaceId: string,
  workplaceCode: string,
  uuid: string
): A3InnuvaMapping => {
  return {
    factorial_id: workplaceId,
    a3innuva_id: workplaceCode,
    meta: {
      uuid: uuid,
    },
  }
}

export const upsertWorkplaceMappings = (
  mappings: A3InnuvaMapping[],
  dropdownItem: Item,
  factorialId: string
) => {
  if (!dropdownItem.value) {
    return mappings.filter((mapping) => mapping.factorial_id !== factorialId)
  }
  const workplaceCode = getWorkplaceCode(dropdownItem['label'])
  const uuid = dropdownItem['value']?.toString()
  let isLegalEntityMapped = false
  const newMappings = mappings.map((mapping) => {
    const newMapping = { ...mapping }
    if (newMapping.factorial_id !== factorialId) return newMapping

    isLegalEntityMapped = true
    newMapping.a3innuva_id = workplaceCode
    if (!newMapping.meta) newMapping.meta = {}
    newMapping.meta.uuid = uuid
    return newMapping
  })
  if (!isLegalEntityMapped) {
    newMappings.push(createWorkplaceMapping(factorialId, workplaceCode, uuid))
  }

  return newMappings
}

const createCompensationMapping = (
  compensationId: string,
  compensationCode: string,
  legalEntityId: string
): A3InnuvaMapping => {
  return {
    factorial_id: compensationId,
    a3innuva_id: compensationCode,
    meta: {
      legal_entity_id: legalEntityId,
    },
  }
}

export const upsertCompensationMappings = (
  mappings: A3InnuvaMapping[],
  dropdownItem: Item,
  factorialId: string,
  legalEntityId: string
) => {
  // Unset mappings
  if (!dropdownItem.value) {
    return mappings.filter(
      (mapping) =>
        mapping?.meta?.legal_entity_id !== legalEntityId || mapping.factorial_id !== factorialId
    )
  }

  const compensationCode = dropdownItem['value']?.toString() || ''
  let isCompensationMapped = false

  // Update mappings
  const newMappings = mappings.map((mapping) => {
    if (mapping?.meta?.legal_entity_id === legalEntityId && mapping.factorial_id === factorialId) {
      mapping.a3innuva_id = compensationCode
      isCompensationMapped = true
    }
    return mapping
  })

  // Add new mappings
  if (!isCompensationMapped) {
    newMappings.push(createCompensationMapping(factorialId, compensationCode, legalEntityId))
  }

  return newMappings
}

const createJobPositionMapping = (
  jobPositionId: string,
  a3JobPositionId: string,
  legalEntityId: string
): A3InnuvaMapping => {
  return {
    factorial_id: jobPositionId,
    a3innuva_id: a3JobPositionId,
    meta: {
      legal_entity_id: legalEntityId,
    },
  }
}

export const upsertJobPositionMappings = (
  mappings: A3InnuvaMapping[],
  dropdownItem: Item,
  factorialId: string,
  legalEntityId: string
) => {
  // Unset mappings
  if (!dropdownItem.value) {
    return mappings.filter(
      (mapping) =>
        mapping?.meta?.legal_entity_id !== legalEntityId || mapping.factorial_id !== factorialId
    )
  }

  const a3JobPositionId = dropdownItem['value']?.toString() || ''
  let isJobPositionMapped = false

  // Update mappings
  const newMappings = mappings.map((mapping) => {
    if (mapping?.meta?.legal_entity_id === legalEntityId && mapping.factorial_id === factorialId) {
      mapping.a3innuva_id = a3JobPositionId
      isJobPositionMapped = true
    }
    return mapping
  })

  // Add new mappings
  if (!isJobPositionMapped) {
    newMappings.push(createJobPositionMapping(factorialId, a3JobPositionId, legalEntityId))
  }

  return newMappings
}
